import React from 'react';
import { DatePicker, ConfigProvider } from 'antd';
import { theme, typography, colors } from '../../../themes/technicalAlerts';

/**
 * Shared date picker component for Technical Alerts system
 * Provides consistent styling and behavior across table popovers and alert cards
 * Eliminates duplication between PopoverSystem.jsx and AlertCard action components
 */
const SharedDatePicker = ({
  selectedDate,
  onChange,
  placeholder = 'selectFixDate',
  size = 'small',
  locale,
  style = {},
  getPopupContainer,
  popupStyle = {},
  t,
  ...props
}) => {
  const defaultStyle = {
    ...typography.body3,
    fontFamily: theme.fontFamily.text,
    ...style
  };

  const defaultPopupStyle = {
    zIndex: theme.zIndex.popover,
    ...popupStyle
  };

  return (
    <ConfigProvider locale={locale}>
      <DatePicker
        size={size}
        placeholder={t ? t(placeholder) : placeholder}
        format="DD/MM/YYYY"
        value={selectedDate}
        onChange={onChange}
        style={defaultStyle}
        getPopupContainer={getPopupContainer}
        popupStyle={defaultPopupStyle}
        onClick={(e) => e.stopPropagation()}
        {...props}
      />
    </ConfigProvider>
  );
};

export default SharedDatePicker;